import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import { Classes } from '../styles'; // 表格 DOM 结构
// div.art-table-wrapper
// └── div.art-loading-wrapper
//     ├── div.art-loading-indicator-wrapper
//     │   └── div.art-loading-indicator
//     │
//     └── div.art-loading-content-wrapper
//         ├── div.art-table
//         │   │
//         │   ├── div.art-table-header
//         │   │  └── table
//         │   │      ├── colgroup
//         │   │      └── thead  注意这里会出现自定义内容，可能存在嵌套表格
//         │   │
//         │   ├── div.art-table-body
//         │   │   ├── div.art-virtual-blank.top
//         │   │   ├── table
//         │   │   │   ├── colgroup
//         │   │   │   └── tbody 注意这里会出现自定义内容，可能存在嵌套表格
//         │   │   └── div.art-virtual-blank.bottom
//         │   │
//         │   ├── div.art-table-footer
//         │   │  └── table
//         │   │      ├── colgroup
//         │   │      └── tfoot  注意这里会出现自定义内容，可能存在嵌套表格
//         │   │
//         │   ├── div.art-lock-shadow-mask
//         │   │   └── div.art-left-lock-shadow
//         │   └── div.art-lock-shadow-mask
//         │       └── div.art-right-lock-shadow
//         │
//         └── div.art-sticky-scroll
//             └── div.art-sticky-scroll-item
//
// 在「可能存在嵌套表格」的情况下，我们可以采用以下的方式来避免「querySelector 不小心获取到了的嵌套表格上的元素」：
//  artTable.querySelector('.art-lock-shadow-mask .art-left-lock-shadow')
// 表格 DOM 结构辅助工具

export var TableDOMHelper = /*#__PURE__*/function () {
  function TableDOMHelper(artTableWrapper) {
    var _context;

    _classCallCheck(this, TableDOMHelper);

    this.artTableWrapper = artTableWrapper;
    this.artTable = artTableWrapper.querySelector(".".concat(Classes.artTable));
    this.tableHeader = this.artTable.querySelector(".".concat(Classes.tableHeader));
    this.tableBody = this.artTable.querySelector(".".concat(Classes.tableBody));
    this.virtual = this.artTable.querySelector(".".concat(Classes.virtual));
    this.tableElement = this.artTable.querySelector(".".concat(Classes.tableBody, " table"));
    this.tableFooter = this.artTable.querySelector(".".concat(Classes.tableFooter));

    var stickyScrollSelector = _concatInstanceProperty(_context = ".".concat(Classes.artTable, " + .")).call(_context, Classes.stickyScroll);

    this.stickyScroll = artTableWrapper.querySelector(stickyScrollSelector);
    this.stickyScrollItem = this.stickyScroll.querySelector(".".concat(Classes.stickyScrollItem));
  }

  _createClass(TableDOMHelper, [{
    key: "getVirtualTop",
    value: function getVirtualTop() {
      return this.tableBody.querySelector(".".concat(Classes.virtualBlank, ".top"));
    }
  }, {
    key: "getTableRows",
    value: function getTableRows() {
      var htmlTable = this.getTableBodyHtmlTable();
      return htmlTable.querySelectorAll("tbody > .".concat(Classes.tableRow));
    }
  }, {
    key: "getTableBodyHtmlTable",
    value: function getTableBodyHtmlTable() {
      return this.artTable.querySelector(".".concat(Classes.tableBody, " table"));
    }
  }, {
    key: "getLeftLockShadow",
    value: function getLeftLockShadow() {
      var _context2;

      var selector = _concatInstanceProperty(_context2 = ".".concat(Classes.lockShadowMask, " .")).call(_context2, Classes.leftLockShadow);

      return this.artTable.querySelector(selector);
    }
  }, {
    key: "getRightLockShadow",
    value: function getRightLockShadow() {
      var _context3;

      var selector = _concatInstanceProperty(_context3 = ".".concat(Classes.lockShadowMask, " .")).call(_context3, Classes.rightLockShadow);

      return this.artTable.querySelector(selector);
    }
  }, {
    key: "getLoadingIndicator",
    value: function getLoadingIndicator() {
      return this.artTableWrapper.querySelector(".".concat(Classes.loadingIndicator));
    }
  }]);

  return TableDOMHelper;
}();